// extracted by mini-css-extract-plugin
export default {"header":"styles_header__-Yy0k","action-menu":"styles_action-menu__Gd-9V"};